export default __webpack_public_path__ + "static/media/logoisonegativo.7f00f440.png";